import React from 'react';
import { styled, pxToRem } from '@withjoy/joykit/theme';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { ComparisonIcon } from '../../CompareToPrice';

type ProviderIconsProps = {
  rates: { provider: string; price: string; priceInMinorUnits: number; url: string }[];
};

const IconWrapper = styled(Box)`
  & > svg {
    border-radius: 200px;
  }
`;

export const ProviderIcons: React.FC<ProviderIconsProps> = ({ rates }) => {
  if (rates.length === 1) {
    return ComparisonIcon[rates[0].provider ?? '']?.large ?? null;
  }

  return (
    <Flex alignItems="center" justifyContent="flex-start">
      <Flex alignItems="center" justifyContent="flex-start" position="absolute">
        {rates.slice(0, 3).map(({ provider }, index) => (
          <IconWrapper key={provider} left={index === 0 ? pxToRem(0) : index === 1 ? pxToRem(-4) : pxToRem(-8)} position="relative" height={pxToRem(24)}>
            {ComparisonIcon[provider]?.small ?? null}
          </IconWrapper>
        ))}
        {rates.length > 3 && (
          <TextV2 typographyVariant="body1" color="mono10" position="relative" left={pxToRem(-4)}>
            +{rates.length - 3}
          </TextV2>
        )}
      </Flex>
    </Flex>
  );
};
